import type { POI } from "@poi-planner/shared";
import { formatTimeBudget } from "../utils/format";

interface DragOverlayCardProps {
  poi: POI;
}

export function DragOverlayCard({ poi }: DragOverlayCardProps) {
  return (
    <div
      className="w-[280px] flex flex-col gap-2 p-3 bg-white border border-border rounded-xl cursor-grabbing opacity-95"
      style={{
        boxShadow:
          "0 12px 32px rgba(0, 0, 0, 0.18), 0 2px 6px rgba(0, 0, 0, 0.08)",
        transform: "rotate(2deg) scale(1.04)",
      }}
    >
      <div className="flex justify-between items-start">
        <span className="text-sm font-bold text-primary">{poi.name}</span>
        <span className="material-symbols-outlined text-neutral text-lg">
          drag_indicator
        </span>
      </div>
      <div className="flex items-center gap-1.5 text-secondary text-xs">
        <span className="material-symbols-outlined text-base">schedule</span>
        <span>Budget: {formatTimeBudget(poi.timeBudget)}</span>
      </div>
    </div>
  );
}
